import { useEffect, useState, useRef } from "react";
import axios from "axios";
// import { useUser } from "../redux/reducers/userReducer";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Box,
  Chip,
  Avatar,
  Tooltip,
  Stack,
  Divider,
  Paper,
  Modal,
  Backdrop,
  Fade,
  TextField,
  IconButton,
  InputAdornment,
  Container,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import SendIcon from "@mui/icons-material/Send";
import StyledTitleDot from "../components/common/StyledTitleDot";
import BreadCrumbs from "../components/Breadcrumbs";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { categoryOptionsFirst } from "./CreateTicket";

const statusMapping = {
  0: "Open",
  1: "Closed",
  2: "In Progress",
};

const statusI18nMapping = {
  Open: "open",
  Closed: "closed",
  "In Progress": "inProgress",
}

const Requests = () => {
  const { t } = useTranslation();

  const theme = useTheme();
  //   const user = useUser();
  //   const { student_id } = user || {};
  const profile = useSelector((state) => state.profile.profile);

  const { agent_id: partner_id } = profile;
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const messagesEndRef = useRef(null);

  const fetchAllTickets = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://webservice.londonist.co.uk/v1/DMCGetTicket",
        {
          api_key: "O0AUQ0KLAD3I71K8YKR82Y6AP",
          partner_id,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setTickets(response?.data?.result);
      // setTickets(RequestData?.result);
      setSelectedTicket(null);
      // setTickets([]);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [selectedTicket?.messages]);

  const handleSendMessage = async () => {
    if (!message.trim() || !selectedTicket) return;
    setSending(true);
    const formData = new FormData();
    formData.append("api_key", "O0AUQ0KLAD3I71K8YKR82Y6AP");
    formData.append("student_id", selectedTicket?.student_id);
    formData.append("message", message?.trim());
    formData.append("ticket", selectedTicket?.id);

    // const formData = {
    //   api_key: "O0AUQ0KLAD3I71K8YKR82Y6AP",
    //   student_id: selectedTicket?.student_id,
    //   message: message?.trim(),
    //   ticket: selectedTicket?.id,
    // };
    try {
      await axios.post(
        "https://webservice.londonist.co.uk/v1/DMCAddMessageToTicket",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      await fetchAllTickets();
      setMessage("");
      scrollToBottom();
    } catch (err) {
      console.error(err);
    } finally {
      setSending(false);
    }
  };

  //   useEffect(() => {
  //     if (student_id) fetchAllTickets();
  //   }, [student_id]);

  useEffect(() => {
    fetchAllTickets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const groupedTickets = {
    Open: [],
    "In Progress": [],
    Closed: [],
  };

  tickets
    .filter((t) => t.status === 1)
    .forEach((ticket) => {
      const mapped = statusMapping[ticket.ticket_status];
      if (groupedTickets[mapped]) {
        groupedTickets[mapped].push(ticket);
      } else {
        groupedTickets["Open"].push(ticket);
      }
    });

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 0:
        return "default";
      case 1:
        return "warning";
      case 2:
      case 3:
        return "error";
      default:
        return "default";
    }
  };

  return (
    <>
      <Typography textTransform={"capitalize"} className="title" variant="h4">
        {t("ticketList")}
        <StyledTitleDot />
      </Typography>
      <BreadCrumbs routs={[t("ticketList")]} />
      <Box>
        {/* <Breadcrumbs items={[{ title: "My Requests" }]} /> */}

        {loading ? (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Container maxWidth="lg">
            <Grid
              container
              spacing={5}
              mt={0}
              px={2}
              pb={10}
              sx={{
                flexWrap: "nowrap",
              }}
            >
              {Object.entries(groupedTickets).map(
                ([statusLabel, ticketList]) => (
                  <Grid
                    sx={{
                      minWidth: { xs: "100%", sm: "370px" },
                    }}
                    item
                    xs={4}
                    key={statusLabel}
                  >
                    <Paper
                      elevation={5}
                      sx={{
                        p: 2,
                        mb: 2,
                        background:
                          statusLabel === "Open"
                            ? theme.palette.secondary.light
                            : statusLabel === "Closed"
                              ? theme.palette.error.light
                              : theme.palette.primary.light,
                        borderRadius: 4,
                        boxShadow: 2,
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            textTransform: 'capitalize',
                            color: statusLabel === "Closed" ? "#fff" : "#fff",
                          }}
                          variant="h6"
                          gutterBottom
                        >
                          {/* {statusLabel.toUpperCase()}  */}
                          {t(statusI18nMapping[statusLabel])}

                          <Chip
                            sx={{
                              fontSize: "18px",
                              color: statusLabel === "Closed" ? "#fff" : "#fff",
                            }}
                            label={ticketList.length}
                            size="medium"
                          />
                        </Typography>
                      </Box>
                    </Paper>

                    <Paper
                      elevation={3}
                      sx={{
                        p: ticketList?.length > 0 ? 2 : 0,
                        height: "100%",
                        minHeight: "100vh",
                        border:
                          ticketList?.length > 0
                            ? `1px solid ${theme.palette.divider}`
                            : `1px solid ${theme.palette.divider}`,
                        boxShadow: "unset !important",
                        filter: "unset !important",
                        //   ticketList?.length > 0
                        //     ? `0 0 3px ${theme.palette.divider}`
                        //     : `0 0 3px ${theme.palette.divider}`,
                        background:
                          ticketList?.length > 0
                            ? statusLabel === "Open"
                              ? theme.palette.background.default
                              : statusLabel === "Closed"
                                ? theme.palette.background.default
                                : theme.palette.background.default
                            : theme.palette.background.default,
                        borderRadius: 4,
                      }}
                    >
                      {ticketList.map((ticket, idx) => (
                        <Card
                          key={ticket.id}
                          sx={{
                            mb: ticketList?.length !== idx + 1 ? 2 : 0,
                            cursor: "pointer",
                          }}
                          onClick={() => setSelectedTicket(ticket)}
                        >
                          <CardContent sx={{ padding: "1rem !important" }}>
                            <Typography variant="subtitle2" fontWeight="bold">
                              {ticket.subject}
                            </Typography>
                            <Typography
                              textTransform={"capitalize"}
                              variant="body2"
                              color="text.secondary"
                              mt={0.5}
                            >
                              {t(categoryOptionsFirst?.find(item => item.name === ticket.category)?.trsText || "")}
                            </Typography>
                            <Stack direction="row" spacing={1} mt={1} mb={1}>
                              <Chip
                                label={ticket.source}
                                size="small"
                                color="info"
                              />
                              <Chip
                                label={`#${ticket.id}`}
                                size="small"
                                variant="outlined"
                              />
                              <Chip
                                sx={{ textTransform: 'uppercase' }}
                                label={
                                  ticket.priority === 3
                                    ? t("urgent")
                                    : ticket.priority === 2
                                      ? t("high")
                                      : ticket.priority === 1
                                        ? t("medium")
                                        : t("low")
                                }
                                size="small"
                                color={getPriorityColor(ticket.priority)}
                              />
                            </Stack>
                            <Divider sx={{ my: 1 }} />
                            <Typography textTransform={"capitalize"} variant="body2" color="text.secondary">
                              {t("lastUpdate")}: {ticket.updated_at}
                            </Typography>
                            <Box
                              display="flex"
                              justifyContent="flex-end"
                              mt={1}
                            >
                              <Tooltip title={ticket.student_name || "Unknown"}>
                                <Avatar sx={{ width: 28, height: 28 }}>
                                  {ticket.student_name?.[0] || "?"}
                                </Avatar>
                              </Tooltip>
                            </Box>
                          </CardContent>
                        </Card>
                      ))}
                    </Paper>
                  </Grid>
                )
              )}
            </Grid>
          </Container>
        )}

        <Modal
          open={Boolean(selectedTicket)}
          onClose={() => setSelectedTicket(null)}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{ backdrop: { timeout: 500 } }}
        >
          <Fade in={Boolean(selectedTicket)} onEntered={scrollToBottom}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
                maxWidth: 600,
                bgcolor: "background.paper",
                borderRadius: 3,
                boxShadow: 24,
                p: 0,
                display: "flex",
                flexDirection: "column",
                height: 500,
              }}
            >
              {selectedTicket && (
                <>
                  <Box
                    p={2}
                    borderBottom={`1px solid ${theme.palette.divider}`}
                  >
                    <Typography textTransform={"capitalize"} variant="h6" fontWeight="bold">
                      {t("ticket")} #{selectedTicket.id} — {selectedTicket.subject}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      flexGrow: 1,
                      overflowY: "auto",
                      p: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: 1.5,
                      background: theme.palette.background.default,
                    }}
                  >
                    {selectedTicket.messages?.map((msg) => (
                      <Box
                        key={msg.id}
                        sx={{
                          alignSelf: !msg.is_student
                            ? "flex-start"
                            : "flex-end",
                          bgcolor: !msg.is_student
                            ? theme.palette.secondary.light
                            : theme.palette.primary.light,
                          px: 2,
                          py: 1,
                          borderRadius: 4,
                          maxWidth: "75%",
                          boxShadow: 1,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ wordBreak: "break-word", color: "#fff" }}
                        >
                          {msg.message}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="#fff"
                          display="block"
                          textAlign="right"
                          mt={0.5}
                        >
                          {msg.added_date}
                        </Typography>
                      </Box>
                    ))}
                    <div ref={messagesEndRef} />
                  </Box>
                  <Box p={2} borderTop={`1px solid ${theme.palette.divider}`}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder={`${t("typeYourMessage")}...`}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      onKeyDown={(e) =>
                        e.key === "Enter" && handleSendMessage()
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleSendMessage}
                              disabled={sending || !message.trim()}
                            >
                              <SendIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </>
              )}
            </Box>
          </Fade>
        </Modal>
      </Box>
    </>
  );
};

export default Requests;
